import { Client } from "@/Common/Api/Client";
import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeImmunizationReport extends IExportableFile {
    patientContactId: string;
}

class FileTypeImmunizationReport extends ExportableFile implements IFileTypeImmunizationReport {
    public patientContactId: string;

    constructor(fields?: IFileTypeImmunizationReport) {
        super(FileType.ImmunizationReport);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string {
        return this.patientContactId;
    }

    public getCleanCopy(): ExportableFile {
        return new FileTypeImmunizationReport(this);
    }

    protected async generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        const response = await Client.postAsync<{ FileName: string }>(
            ServerOperations.Server.Myle_Patient_MedicalItem_GenerateImmunizationPdf,
            {
                PatientContactId: this.patientContactId
            }
        );

        if (!response.isSuccess)
            return;

        const fetchUrl = FileSelectionHelper.getFetchUrl(response.data.FileName, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }

    public getMeta(): Promise<number> {
        throw new Error("Method not implemented.");
    }
}

export { FileTypeImmunizationReport };
